import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { SearchBlock } from 'components/common/parts';
import { UniversalTable } from 'components/common/universal';
import { SearchableTable, SearchableTableContainer } from 'containers';
import { getUserSurveysAction } from 'actions';
import { makeSelector } from 'utils';
import { SurveysTableParams } from 'assets/static-data';
import { QueryParams, SurveysList } from 'interfaces';
import { getMatchParam } from 'helpers';

interface IProps extends SearchableTable {}

const UsersSurveys: React.FC<IProps> = ({
  match,
  getList,
  isLoading,
  queryParams,
}) => {
  const { data, recordsFiltered } = useSelector<any, SurveysList>(
    makeSelector(['usersReducer', 'surveysList'])
  );

  const idFromUrl = getMatchParam(match).id;

  useEffect(() => {
    onGetList(queryParams);
  }, []);

  const onGetList = (params: QueryParams) => {
    getList({ ...params, id: idFromUrl });
  };

  return (
    <>
      <SearchBlock onChange={getList} initialQuery={queryParams} />
      <UniversalTable
        {...SurveysTableParams}
        data={data}
        total={recordsFiltered}
        onChange={onGetList}
        isLoading={isLoading}
        initialQuery={queryParams}
      />
    </>
  );
};

export default SearchableTableContainer({
  getListAction: getUserSurveysAction,
  isInitialized: false,
  reducerName: 'usersReducer',
  queryName: 'surveysQueryParams',
  isEqualSearch: true,
})(UsersSurveys);
